<template>
    <div class="w-full">
        <div v-for="(dataset, index) in datasets" :key="index" class="w-full flex flex-col border-b border-white mb-4">
            <div v-if="dataset.value || dataset.unit" class="text-heading-3">
                {{ dataset.unit || '' }}
                {{ dataset.value || '' }}
                &nbsp;{{ dataset.scale !== 'none' ? dataset.scale : '' || '' }}
            </div>
            <div
                v-if="dataset.description"
                class="text-para-xs mb-1 text-black-100 whitespace-pre-line"
                v-html="dataset.description" />
            <a
                v-if="dataset.link"
                class="mb-1 text-para-xs text-black-100 whitespace-pre-line italic inline-flex items-center"
                :href="dataset.link.url"
                :target="dataset.link.target"
                ><span>{{ dataset.link.label }}</span
                ><span class="w-8 h-8"><ArrowButton :direction="dataset.link.icon" :zoom-level="1" /></span
            ></a>
        </div>
    </div>
</template>

<script lang="ts">
import ArrowButton from '../base/ArrowButton.vue';

export interface Dataset {
    unit: string;
    value: string;
    scale: string;
    description: string;
    link: {
        url: string;
        label: string;
        target: string;
        icon: string;
    };
}

export default {
    components: { ArrowButton },
    props: {
        datasets: { type: Array<Dataset>, required: true, default: () => [] },
    },
};
</script>
